var _path, _g, _path2, _g2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4120_12400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.84931V7.47704H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4120_12400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84931 0.0276205C9.61742 0.0109197 9.3824 0 9.14538 0C4.55944 0 0.751625 3.22614 0 7.46411C0.0573077 7.46845 0.115112 7.4731 0.172751 7.47712C0.349643 7.46893 1.06301 7.46893 1.24123 7.4768C5.57905 7.23592 9.126 4.09474 9.84931 0.0276205Z",
    fill: "#FF4E00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4120_12400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 10,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05176e-05 10.522H9.84934V18.0004H3.05176e-05V10.522Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4120_12400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24126 10.522C1.06304 10.5286 0.349674 10.5286 0.173444 10.522C0.114977 10.5244 0.0573382 10.5297 3.05176e-05 10.534C0.751656 14.7734 4.55931 18.0004 9.14541 18.0004C9.38226 18.0004 9.61729 17.9882 9.84934 17.9715C9.12603 13.904 5.57892 10.762 1.24126 10.522Z",
    fill: "#FF4E00"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4466 1.61328C13.3102 4.78016 10.5387 7.43109 7.23343 8.99983C10.5387 10.5676 13.3102 13.2201 14.4466 16.3859C16.853 14.76 18.4275 12.0585 18.4275 8.99983C18.4275 5.9399 16.853 3.23952 14.4466 1.61328Z",
    fill: "#FF4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmIcon);
export default __webpack_public_path__ + "static/media/km_Icon.03ff8c0f818f7d33cc17c73201252739.svg";
export { ForwardRef as ReactComponent };